import { useState, type FormEvent } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';

export default function AdminLogin() {
  const { user, loading, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) {
    const redirectTo = (location.state as { from?: string } | null)?.from ?? '/admin';
    return <Navigate to={redirectTo} replace />;
  }

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(email, password);
      navigate('/admin');
    } catch {
      setError('E-mail ou senha inválidos.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-secondary-900 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <img src="/navbar-logo-v2.png" alt="BNI" className="h-12 mx-auto mb-4 brightness-0 invert" />
          <h1 className="text-xl font-bold text-background-50">Área Administrativa</h1>
          <p className="text-sm text-background-400 mt-1">Faça login para gerenciar os imóveis</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-background-50 rounded-lg p-6 md:p-8 shadow-xl">
          <div className="mb-4">
            <label className="text-xs font-semibold text-foreground-700 block mb-2">E-mail</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-background-100 border border-background-300/60 rounded-md px-3 py-2.5 text-sm text-foreground-800 focus:outline-none focus:ring-2 focus:ring-primary-400"
              placeholder="seuemail@grupobni.com.br"
              autoComplete="username"
            />
          </div>

          <div className="mb-5">
            <label className="text-xs font-semibold text-foreground-700 block mb-2">Senha</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-background-100 border border-background-300/60 rounded-md px-3 py-2.5 text-sm text-foreground-800 focus:outline-none focus:ring-2 focus:ring-primary-400"
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <p className="text-xs text-red-600 bg-red-50 rounded-md px-3 py-2 mb-4">{error}</p>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-primary-500 text-background-50 py-2.5 rounded-md text-sm font-semibold hover:bg-primary-600 transition-colors disabled:opacity-60"
          >
            {submitting ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </main>
  );
}
